// Storage keys for admin portal
// Prefixed with 'admin_' to avoid conflicts with member portal

export const STORAGE_KEYS = {
  USE_REAL_API: 'admin_useRealAPI',
  AUTH_SESSION: 'admin_auth_session', // Only stores non-sensitive session info
  WELCOME_MESSAGE: 'admin_welcomeMessage',
  USERS: 'admin_users',
  PERMISSIONS: 'admin_permissions',
  SURVEY_STEPS: 'admin_survey-steps'
  // USER key removed - no user data stored in localStorage for security
};